import React, { useState, useEffect } from "react";
import {
  Form,
  Typography,
  Input,
  Space,
  Button,
  Radio,
  Select,
  Switch,
} from "antd";

import { SaveOutlined, UndoOutlined } from "@ant-design/icons";

//Importaciones para el uso de Redux
import { useDispatch } from "react-redux";
import { updateRolEnviromentAction } from "../../../actions/rolEnviromentActions";
//Styles
import curStyle from "../../../css/GlobalCmp.module.css";

//Importaciones Propias
import CST from "../../../utils/CustomSettings";
import { showNotification } from "../../../utils/ShowNotification";
import FRM from "../../../utils/FrmService";

export default function CjbCncDbyCrForm(props) {
  const { record, clases_cnc, closeModal, currentUser, varEffec } = props;
  const [form] = Form.useForm();
  const [curId, setCurId] = useState(record.cnc_id);
  const [loadingButton, setLoadingButton] = useState(false);
  const [cncTipo, setCncTipo] = useState(record.cnc_tipo);
  const [cncClase, setCncClase] = useState(record.cnc_clase);
  const [activo, setActivo] = useState();

  useEffect(() => {
    setCurId(record.cnc_id);
  }, [varEffec]);

  //Ejecutar dispatch tras el logueo
  const dispatch = useDispatch();
  const updateEnviroment = (state) =>
    dispatch(updateRolEnviromentAction(state));

  const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
  };

  const { Title } = Typography;
  const { Option } = Select;

  const guardarCambios = async (values) => {
    console.log(values);
    setLoadingButton(true);
    let val_record = await FRM.sendGstConceptos(
      currentUser,
      curId,
      activo,
      "GstConceptos",
      values
    );
    console.log(val_record);
    if (Number.parseInt(val_record.type) > 0) {
      updateEnviroment(val_record.datos.rol_entorno);
      showNotification(
        "topRight",
        4,
        "GESTION DE CONCEPTOS DE NOTAS DB Y CR",
        "REGISTRO EXITOSO"
      );
    } else {
      showNotification(
        "topRight",
        2,
        "GESTION DE CONCEPTOS DE NOTAS DB Y CR",
        val_record.message
      );
    }
    setLoadingButton(false);
    closeModal();
  };

  //Renderizacion del componente
  return (
    <Form
      {...layout}
      form={form}
      name="gstconceptos"
      onFinish={guardarCambios}
      initialValues={{
        cnc_nombre: record.cnc_id > 0 ? record.cnc_nombre : "",
        cnc_tipo: record.cnc_id > 0 ? record.cnc_tipo : "",
      }}
      scrollToFirstError
    >
      <Form.Item>
        <Title
          level={4}
          style={{
            padding: 2,
            margin: 2,
            fontWeight: 600,
            textAlign: "left",
            color: CST.colorSec,
          }}
        >
          {record.cnc_id > 0
            ? "ACTUALIZAR CONCEPTO DE NOTAS DB Y CR"
            : "AGREGAR CONCEPTO DE NOTAS DB Y CR"}
        </Title>
      </Form.Item>
      <Form.Item
        name="cnc_nombre"
        label="Nombre"
        rules={[
          {
            required: true,
            message: "El nombre es obligatorio",
          },
        ]}
      >
        <Input
          style={{ textTransform: "uppercase" }}
          value={record.cnc_id > 0 ? record.cnc_nombre : ""}
        />
      </Form.Item>
      <Form.Item
        name="cnc_tipo"
        label="Tipo"
        rules={[
          {
            required: true,
            message: "El tipo es obligatorio",
          },
        ]}
      >
        <Space direction="horizontal">
          <Radio.Group
            onChange={(option) => setCncTipo(option.target.value)}
            value={cncTipo}
            style={{ marginRight: 70 }}
          >
            <Radio value={1}>Debito</Radio>
            <Radio value={2}>Credito</Radio>
          </Radio.Group>
          <Space></Space>
          Activo:
          <Switch
            checked={activo}
            onChange={(val) => setActivo(val)}
            checkedChildren="SI"
            unCheckedChildren="NO"
          />
        </Space>
      </Form.Item>
      <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 4 }}>
        <Space>
          <Button
            type="primary"
            htmlType="submit"
            className={curStyle.btnOrange}
            loading={loadingButton}
          >
            <SaveOutlined /> Guardar
          </Button>
          <Button
            type="primary"
            className={curStyle.btnInverse}
            onClick={() => closeModal()}
          >
            <UndoOutlined /> Cancelar
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
}
